import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getWizardV2State } from '../wizardService';
import Input from '../../../components/forms/Input';
import { EMAIL_REGEXP } from '../../../constants/constants';
import { setCurrentStep, setDataV2 } from '../onboardingSlice';
import { ONBOARDING_STEP_EVENT, ONBOARDING_SKIP_HOME_EVENT, ONBOARDING_V2_SKIP_EMAIL_EVENT } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import FadeTransition from '../../../components/animations/FadeTransition';
import Checkbox from '../../../components/forms/Checkbox';
import { setUser } from '../../user/userSlice';
import { isMobile } from '../../../utilities/helpers';
import EmailStepDesktop from '../../wizardDesktop/steps/EmailStepDesktop';
import useStartWizardSearch from '../useStartWizardSearch';
import { sendSearchPerformed } from '../../../utilities/sendSearchPerformed';
import { selectDealsList } from '../../../features/dealsList/dealsListSlice';

const EmailStep = () => {
  const dispatch = useDispatch();
  const { formV2: form, step } = useSelector(state => state.onboarding);
  const [email, setEmail] = useState(form.email);
  const [emailValid, setEmailValid] = useState(EMAIL_REGEXP.test(form.email));
  const { emailStep: data } = getWizardV2State();
  const showMarketingCheckbox = window.holidayFinder.abTest?.emailStepWithMarketing || data.marketingCheckbox;
  const showSkipLink = !!(data.skipTextRow);
  const { startSearch } = useStartWizardSearch();
  const { dealsList } = useSelector(selectDealsList);

  useEffect(() => {
    startSearch();
  }, [])

  const onChangeEmail = (email) => {
    if (EMAIL_REGEXP.test(email)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }

    dispatch(setDataV2({ email }));
    setEmail(email);
  }

  const handleCheckboxChange = (event) => {
    dispatch(setDataV2({
      email,
      marketingCheckbox: event.target.checked,
    }))
  };

  const setLoginPopupFlag = () => {
    localStorage.setItem('wizardEmailEntered', true);
    sessionStorage.setItem('wizardEmailEntered', true);
  }

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      wizardV2: true,
      stepName: 'email',
      question: data.title,
      selection: email,
      marketingCheckboxEnabled: showMarketingCheckbox,
      marketingCheckbox: form.marketingCheckbox,
      skipAvailable: true,
    });

    if (email) {
      // TODO: maybe use user from reducer
      const hfUser = JSON.parse(localStorage.getItem('hf_user'));

      if (hfUser) {
        // eslint-disable-next-line no-undef
        user.updateUserContext({
          ...hfUser,
          user: {
            ...hfUser.user,
            email,
          },
          userNotificationPreferences: {
            ...hfUser.userNotificationPreferences,
            enabledNewsletter: form.marketingCheckbox,
            enabledSA: true,
            enabledCA: true,
          }
        }, hfUser.user.muid, false, 'wizard').then((res) => {
          console.log('email step: ', res)
          const hfUser = JSON.parse(localStorage.getItem('hf_user'));
          dispatch(setUser(hfUser));
          if (typeof updateLoginButton !== 'undefined' && hfUser && hfUser?.user?.userLevel === 'USER_EMAIL' && hfUser?.user?.user_auth) {
            // eslint-disable-next-line no-undef
            updateLoginButton(true, hfUser?.user?.firstName, hfUser?.user?.muid);
          }
          setLoginPopupFlag();
          // send search performed request after user filled email
          let minOfferPrice = null;
          if (dealsList?.length) {
            const minOffer = dealsList.reduce((prev, curr) => prev.offer.price < curr.offer.price ? prev : curr);
            if (minOffer && minOffer.offer) {
              const { capacity_from_filter } = minOffer.offer;
              let kids = capacity_from_filter.child;
              const babies = capacity_from_filter.childAges.filter((kid) => kid < 2).length || 0;
              kids = kids - babies; // calculate price per person without babies
              const minPricePerPerson = Math.ceil(minOffer.offer.price / (capacity_from_filter.adult + kids));
              minOfferPrice = minPricePerPerson;
              window.minOfferPricePP = minPricePerPerson;
            }
          }
          sendSearchPerformed(minOfferPrice);
        });
      }
    }
  }

  const onSkipEmail = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_SKIP_HOME_EVENT, { skipFrom: 'email step skip link' })
    pushEvent(ONBOARDING_V2_SKIP_EMAIL_EVENT, { skipFrom: 'email step skip link' })
  }

  if (!isMobile()) {
    return (
      <EmailStepDesktop
        data={data}
        email={email}
        onChangeEmail={onChangeEmail}
        form={form}
        showMarketingCheckbox={showMarketingCheckbox}
        handleCheckboxChange={handleCheckboxChange}
        showSkipLink={showSkipLink}
        onSkipEmail={onSkipEmail}
        onContinueClick={handleContinueClick}
        emailValid={emailValid}
      />
    )
  }

  return (
    <>
      <div className="wizard-step wizard-email-step">
        <div className="wizard-step__title">{data.title}</div>
        <div className="wizard-step__email">
        <Input
          variant="wizard"
          type="email"
          placeholder={data.textInsideEmailBox}
          value={email}
          onChange={onChangeEmail}
        />

        <FadeTransition in={emailValid} unmountOnExit>
          <div>
            <div className="wizard-step__hint">{data.textBelowEmail}</div>
            {showMarketingCheckbox && (
              <div className="consent-message">
                <Checkbox
                  label={data.marketingCheckboxText}
                  checked={form.marketingCheckbox}
                  onChange={handleCheckboxChange}
                  wrapClassNames="wizard-checkbox"
                />
              </div>
            )}
          </div>
        </FadeTransition>
        {showSkipLink && (
          <div className="wizard-email__skip">
            <span className="wizard-email__skip-link" onClick={onSkipEmail}>{data.skipTextRow}</span>
          </div>
        )}
        </div>
      </div>
      <div className="wizard-footer">
        <button className="wizard-control-button" disabled={!emailValid} onClick={handleContinueClick}>{data.buttonText}</button>
      </div>
    </>
  )
}

export default EmailStep
